// @ts-nocheck c3f301ee
import * as stateManagement from '#packages/stateManagement';

const trackAppUpgrade = function (editorAPI, applicationId) {
  editorAPI.store.dispatch(
    stateManagement.tpa.actions.addAppToTrackForUpgrade(applicationId),
  );
};

export { trackAppUpgrade };
